<template>
  <div class="waves-container">
    <div class="waves-header">
      <h3>波次管理</h3>
      <el-button v-if="!isOpsRole" type="primary" icon="el-icon-plus" class="btn-create" @click="showCreateDialog">新建波次</el-button>
    </div>
    
    <!-- 波次列表 -->
    <div class="table-card">
      <el-table ref="waveTable" :data="waveList" v-loading="loading" class="proto-table" :show-overflow-tooltip="true">
        <el-table-column type="expand">
          <template slot-scope="{ row }">
            <div class="expand-dealer" v-loading="row._dealerLoading">
              <div class="dealer-header-row">
                <div class="expand-title">{{ row.Name || row.name }} — 经销商名单</div>
                <div class="dealer-filter-bar">
                  <el-input v-model="row._filterKeyword" placeholder="搜索门店编码/名称" size="mini" clearable style="width:180px" @keyup.enter.native="applyDealerFilter(row)" @clear="applyDealerFilter(row)" />
                  <el-select v-model="row._filterAgent" placeholder="代理" size="mini" clearable style="width:110px" @change="applyDealerFilter(row)">
                    <el-option label="已分配" :value="true" />
                    <el-option label="未分配" :value="false" />
                  </el-select>
                  <el-select v-model="row._filterShopper" placeholder="神客" size="mini" clearable style="width:110px" @change="applyDealerFilter(row)">
                    <el-option label="已分配" :value="true" />
                    <el-option label="未分配" :value="false" />
                  </el-select>
                  <el-button size="mini" icon="el-icon-search" @click="applyDealerFilter(row)">筛选</el-button>
                </div>
              </div>
              <el-table :data="row._dealers || []" class="proto-table sub-table" size="small">
                <el-table-column label="门店编码" width="100">
                  <template slot-scope="{ row: d }">
                    <span style="color:#6b7280;font-size:13px;">{{ d.DealerCode || d.dealerCode }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="门店名称" min-width="120">
                  <template slot-scope="{ row: d }">
                    <span style="font-weight:600;" :style="(d.IsVoided || d.isVoided) ? 'color:#94a3b8;text-decoration:line-through;' : ''">{{ d.DealerName || d.dealerName }}</span>
                    <el-tag v-if="d.IsVoided || d.isVoided" size="mini" type="danger" effect="plain" style="margin-left:6px">已作废</el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="代理" width="120" align="center">
                  <template slot-scope="{ row: d }">
                    <span class="agent-cell" @click.stop="showChangeAgent(d)">
                      <span v-if="d.AgentName || d.agentName">{{ d.AgentName || d.agentName }}</span>
                      <span v-else style="color:#9ca3af;">未分配</span>
                      <i class="el-icon-edit" style="margin-left:4px;font-size:12px;color:#2563eb;"></i>
                    </span>
                  </template>
                </el-table-column>
                <!-- 省份/城市统一在「厂家基础信息 → 经销商管理」里维护，此处仅展示从 dealers_tb 读出的值 -->
                <el-table-column label="省份" width="100">
                  <template slot-scope="{ row: d }">
                    <span style="color:#6b7280;">{{ d.Province || d.province || '—' }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="城市" width="100">
                  <template slot-scope="{ row: d }">
                    <span style="color:#6b7280;">{{ d.City || d.city || '—' }}</span>
                  </template>
                </el-table-column>
                <!-- 阶段进度 -->
                <el-table-column label="阶段进度" min-width="280">
                  <template slot-scope="{ row: d }">
                    <div class="phase-list">
                      <span v-for="(ps, idx) in (d.PhaseStatuses || d.phaseStatuses || [])" :key="idx"
                        class="phase-tag" :class="getPhaseTagClass(ps)">
                        {{ (ps.PhaseName || ps.phaseName) }}: {{ ps.StatusText || ps.statusText }}
                      </span>
                      <span v-if="!(d.PhaseStatuses || d.phaseStatuses || []).length" style="color:#9ca3af;">—</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="神客信息" min-width="150">
                  <template slot-scope="{ row: d }">
                    <div v-if="(d.ShopperName || d.shopperName || d.ShopperPhone || d.shopperPhone)">
                      <div style="font-weight: 600;">{{ d.ShopperName || d.shopperName || '—' }}</div>
                      <div style="color:#6b7280;font-size:12px;">{{ d.ShopperPhone || d.shopperPhone || '—' }}</div>
                    </div>
                    <span v-else style="color:#9ca3af;">未分配神客</span>
                  </template>
                </el-table-column>
                <el-table-column label="入口链接" min-width="100">
                  <template slot-scope="{ row: d }">
                    <template v-if="d.QrcodeUrl || d.qrcodeUrl">
                      <el-link type="primary" :href="d.QrcodeUrl || d.qrcodeUrl" target="_blank" style="font-size:12px;">
                        查看
                      </el-link>
                      <el-button type="text" icon="el-icon-copy-document" size="mini" @click="copyLink(d.QrcodeUrl || d.qrcodeUrl)"></el-button>
                    </template>
                    <template v-else-if="getWaveEnableUniqueCode(d) === 0">
                      <el-link type="success" style="font-size:12px;" @click="copyEntryLink(d)">
                        <i class="el-icon-link"></i> 复制公共入口
                      </el-link>
                    </template>
                    <span v-else style="color:#9ca3af;">—</span>
                  </template>
                </el-table-column>
              </el-table>
              <div class="dealer-pagination" v-if="(row._dealerTotal || 0) > 10">
                <el-pagination
                  small
                  layout="total, prev, pager, next"
                  :current-page="row._dealerPage || 1"
                  :page-size="10"
                  :total="row._dealerTotal || 0"
                  @current-change="(p) => handleDealerPageChange(row, p)"
                />
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="波次名称" min-width="200">
          <template slot-scope="{ row }">
            <div class="name-cell">
              <div class="icon-box blue"><i class="el-icon-document"></i></div>
              <div>
                <div class="row-title">{{ row.Name || row.name }}</div>
                <div class="row-sub">{{ getFormNameByKeys(row.FormKeys || row.formKeys) }}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="120" align="center">
          <template slot-scope="{ row }">
            <span class="status-badge" :class="getStatusClass(row.status || row.Status)">
              <span class="dot"></span>{{ getStatusText(row.status || row.Status) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="经销商数" width="110" align="center">
          <template slot-scope="{ row }">
            <span class="count-num">{{ row.DealerCount || row.dealerCount || 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="更新时间" width="160">
          <template slot-scope="{ row }">
            <div>{{ (row.StartTime || row.startTime || '').split(' ')[0] || '—' }}</div>
            <div class="time-sub">{{ (row.StartTime || row.startTime || '').split(' ')[1] || '' }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="280" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="toggleDealers(row)">经销商</el-button>
            <el-button type="text" size="small" :disabled="hasAssignedShopper(row)" @click="uploadDealers(row)">导入名单</el-button>
            <el-button type="text" size="small" @click="exportAssignList(row)">导出名单</el-button>
            <el-button v-if="!isOpsRole && (row.EnableUniqueCode || row.enableUniqueCode) !== 0" type="text" size="small" @click="generateCodes(row)">生成码</el-button>
            <el-button type="text" size="small" @click="exportQRCodes(row)">导出二维码</el-button>
            <el-button v-if="!isOpsRole" type="text" size="small" @click="editWave(row)">编辑</el-button>
            <el-button v-if="!isOpsRole" type="text" size="small" class="text-danger" @click="deleteWave(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    
    <!-- 新建/编辑波次对话框 -->
    <el-dialog :title="isEdit ? '编辑波次' : '新建波次'" :visible.sync="dialogVisible" width="650px">
      <el-form :model="waveForm" :rules="rules" ref="waveForm" label-width="100px">
        <el-form-item label="波次名称" prop="name">
          <el-input v-model="waveForm.name" placeholder="请输入波次名称"></el-input>
        </el-form-item>
        
        <!-- #25 阶段配置 -->
        <el-form-item label="阶段配置">
          <div v-for="(phase, idx) in waveForm.phases" :key="phase.phaseNo" class="phase-config-row">
            <span class="phase-no">阶段{{ phase.phaseNo }}</span>
            <el-select 
              v-model="phase.formId" 
              filterable 
              :placeholder="phase.phaseNo === 3 ? '选择考试测评问卷' : '选择普通问卷'" 
              size="small"
              style="width: 200px;"
            >
              <el-option 
                v-for="form in getFilteredForms(phase.phaseNo)" 
                :key="form.id" 
                :label="getFormName(form)" 
                :value="String(form.id)"
              ></el-option>
            </el-select>
            <el-input 
              v-model="phase.phaseName" 
              size="small" 
              placeholder="阶段名称" 
              style="width: 130px; margin-left: 8px;"
            ></el-input>
            <span class="phase-type-hint">{{ phase.phaseNo === 3 ? '主体问卷' : '资料回收' }}</span>
            <el-button 
              v-if="waveForm.enablePhaseOrder ? (phase.phaseNo === 2 || phase.phaseNo === 4) : (phase.phaseNo !== 3)" 
              icon="el-icon-delete" 
              size="mini" 
              type="text" 
              class="text-danger"
              style="margin-left: 4px;"
              @click="removePhase(idx)"
            ></el-button>
            <el-tag v-if="phase.phaseNo === 3 || (waveForm.enablePhaseOrder && phase.phaseNo === 1)" size="mini" type="info" style="margin-left:4px;">必选</el-tag>
          </div>
          <el-button 
            v-if="waveForm.phases.length < 4" 
            icon="el-icon-plus" 
            size="small" 
            @click="addPhase"
            style="margin-top: 8px;"
          >添加可选阶段</el-button>
          <p class="phase-hint-text">{{ waveForm.enablePhaseOrder ? '按顺序填写模式：阶段1、3 为必选，阶段2、4 为可选' : '自由填写模式：仅阶段3 为必选，阶段1、2、4 为可选' }}。阶段3 为主体问卷（仅可选择考试测评类型问卷），其余为资料回收（普通问卷）</p>
        </el-form-item>

        <el-form-item label="阶段顺序">
          <el-switch v-model="waveForm.enablePhaseOrder" active-text="必须按顺序填写"></el-switch>
        </el-form-item>

        <el-form-item label="答题入口">
          <el-radio-group v-model="waveForm.enableUniqueCode" :disabled="isEdit && hasGeneratedCodes">
            <el-radio :label="1">一店一码 <span style="color:#9ca3af;font-size:12px;">（每店独立链接）</span></el-radio>
            <el-radio :label="0">手机号匹配 <span style="color:#9ca3af;font-size:12px;">（统一入口，输入手机号匹配门店）</span></el-radio>
          </el-radio-group>
          <div v-if="isEdit && hasGeneratedCodes" style="color:#f59e0b;font-size:12px;margin-top:4px;">
            <i class="el-icon-warning"></i> 已生成一店一码，无法切换模式
          </div>
        </el-form-item>

        <el-form-item label="时间范围">
          <el-date-picker
            v-model="waveForm.timeRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 100%;"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveWave" :loading="saving">确定</el-button>
      </div>
    </el-dialog>
    
    <!-- 上传经销商名单对话框 -->
    <el-dialog title="上传经销商名单" :visible.sync="uploadDialogVisible" width="500px" @open="clearUploadList">
      <el-upload
        ref="uploadRef"
        drag
        action="#"
        :auto-upload="false"
        :on-change="handleFileChange"
        :file-list="fileList"
        accept=".xlsx,.xls"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将 Excel 文件拖到此处，或<em>点击上传</em></div>
      </el-upload>
      <div class="upload-tips">
        <p>支持 xlsx、xls 格式</p>
        <p class="text-muted">模板列：门店编码 | 门店名称 | 代理手机号(可选)</p>
        <el-button type="text" icon="el-icon-download" @click="downloadTemplate" style="padding:4px 0;font-size:13px;">下载导入模板</el-button>
      </div>
      <div slot="footer">
        <el-button @click="uploadDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmUpload" :loading="uploading">确认上传</el-button>
      </div>
    </el-dialog>
    
    <!-- 更换代理弹窗（多选） -->
    <el-dialog title="更换代理" :visible.sync="agentDialogVisible" width="450px">
      <p style="margin-bottom:12px;">门店：<strong>{{ agentDealer ? (agentDealer.DealerName || agentDealer.dealerName) : '' }}</strong></p>
      <el-select v-model="selectedAgentIds" multiple filterable clearable placeholder="选择代理（可多选，留空则清除）" style="width:100%;" v-loading="loadingAgentCurrent">
        <el-option v-for="a in agentOptions" :key="a.Id || a.id" :label="`${a.Name || a.name} (${a.Phone || a.phone || ''})`" :value="a.Id || a.id"></el-option>
      </el-select>
      <div slot="footer">
        <el-button round @click="agentDialogVisible = false">取消</el-button>
        <el-button type="primary" round @click="confirmChangeAgent" :loading="changingAgent">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { pageFormRequest } from 'index/api/project/form'
import { 
  getWaveList, 
  createWave, 
  updateWave, 
  deleteWave as deleteWaveApi,
  getWaveDealers,
  uploadDealerList,
  generateDealerCodes,
  exportDealerAssignList,
  exportDealerQRCodes,
  getAgentOptions,
  changeDealerAgent,
  getDealerAgents,
  exportDealerTemplate
} from 'index/api/project/wave'

export default {
  name: 'ProjectWaves',
  
  data() {
    return {
      loading: false,
      saving: false,
      uploading: false,
      waveList: [],
      formList: [],
      dealerList: [],
      dialogVisible: false,
      uploadDialogVisible: false,
      dealerDialogVisible: false,
      isEdit: false,
      currentWave: null,
      uploadFile: null,
      fileList: [],  // 上传组件的文件列表
      agentDialogVisible: false,
      agentDealer: null,
      selectedAgentIds: [],
      agentOptions: [],
      changingAgent: false,
      loadingAgentCurrent: false,
      hasGeneratedCodes: false,
      waveForm: {
        name: '',
        phases: [
          { phaseNo: 1, formId: '', phaseName: '神秘顾客信息' },
          { phaseNo: 3, formId: '', phaseName: '服务评分' }
        ],
        enablePhaseOrder: false,
        enableUniqueCode: 1,
        timeRange: []
      },
      rules: {
        name: [{ required: true, message: '请输入波次名称', trigger: 'blur' }]
      }
    }
  },
  
  computed: {
    projectId() {
      return this.$route.params.projectId
    },
    isOpsRole() {
      const info = this.$store.getters.userInfo || {}
      const sysRole = (info.roles && info.roles.name) || info.role_name || info.roleName || ''
      return sysRole === '执行'
    }
  },
  
  mounted() {
    this.loadWaves()
    this.loadForms()
  },
  
  methods: {
    hasAssignedShopper(row) {
      const dealers = row._dealers || []
      return dealers.some(d => !!(d.ShopperName || d.shopperName || d.ShopperPhone || d.shopperPhone))
    },

    async loadWaves() {
      this.loading = true
      try {
        const res = await getWaveList(this.projectId)
        // 后端响应结构: res.data = {success, data: {Rows, TotalRows, ...}}
        const data = res?.data?.data || res?.data || {}
        // 兼容多种字段名
        this.waveList = data.Rows || data.rows || data.records || []
      } catch (e) {
        // axios拦截器拒绝时数据可能在 e.data 中
        const data = e?.data?.data || e?.data || {}
        const rows = data.Rows || data.rows || data.records || []
        if (rows.length > 0) {
          this.waveList = rows
        } else {
          console.error('加载波次列表失败', e)
        }
      } finally {
        this.loading = false
      }
    },
    
    async loadForms() {
      try {
        const res = await pageFormRequest({ projectId: this.projectId, pageSize: 100 })
        // 响应结构: res.data = {success, errcode, message, data: {records, total, size}}
        const records = res?.data?.data?.records || res?.data?.records || []
        this.formList = records
      } catch (e) {
        // axios拦截器拒绝时数据可能在 e.data 中
        const records = e?.data?.data?.records || e?.data?.records || []
        if (records.length > 0) {
          this.formList = records
        } else {
          console.error('加载问卷列表失败', e)
        }
      }
    },
    
    // 去除HTML标签，获取纯文本问卷名称
    getFormName(form) {
      const name = form.textName || form.name || '未命名问卷'
      return name.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').replace(/&amp;/g, '&').trim()
    },

    // 根据阶段号过滤问卷列表：阶段3只能选考试测评(type=3)，其他阶段只能选普通问卷(type≠3)
    getFilteredForms(phaseNo) {
      if (phaseNo === 3) {
        return this.formList.filter(f => (f.type || f.formType) === 3)
      }
      return this.formList.filter(f => (f.type || f.formType) !== 3)
    },
    
    // 根据formKeys数组获取问卷名称（用于表格显示）
    getFormNameByKeys(formKeys) {
      if (!formKeys || !Array.isArray(formKeys) || formKeys.length === 0) {
        return '-'
      }
      // 从formList中查找对应的问卷名称（使用问卷ID匹配）
      const names = formKeys.map(key => {
        const form = this.formList.find(f => String(f.id) === String(key))
        return form ? this.getFormName(form) : key
      })
      return names.join(', ') || '-'
    },
    
    getStatusType(status) {
      const map = { 0: 'info', 1: 'success', 2: 'warning' }
      return map[status] || 'info'
    },
    
    getStatusText(status) {
      const map = { 0: '未开始', 1: '进行中', 2: '已结束' }
      return map[status] || '未知'
    },
    getWaveEnableUniqueCode(dealer) {
      // 从波次列表中找到该门店所属波次的 EnableUniqueCode
      const waveId = dealer.WaveId || dealer.waveId
      const wave = this.waveList.find(w => (w.Id || w.id) == waveId)
      if (wave) return wave.EnableUniqueCode !== undefined ? wave.EnableUniqueCode : (wave.enableUniqueCode !== undefined ? wave.enableUniqueCode : 1)
      return 1
    },
    copyEntryLink(dealer) {
      const waveId = dealer.WaveId || dealer.waveId
      const base = window.location.origin
      const link = `${base}/s/entry?wave=${waveId}`
      this.copyLink(link)
    },
    getStatusClass(status) {
      const map = { 0: 'info', 1: 'success', 2: 'danger' }
      return map[status] || 'info'
    },
    getDealerStatusClass(row) {
      if ((row.Status || row.status) === 2) return 'success'
      if (row.QrcodeUrl || row.qrcodeUrl) return 'warning'
      return 'info'
    },
    getDealerStatusText(row) {
      if ((row.Status || row.status) === 2) return '已完成'
      if (row.QrcodeUrl || row.qrcodeUrl) return '待填写'
      return '待生成'
    },
    getPhaseTagClass(ps) {
      const s = ps.Status || ps.status || ''
      const map = { 'not_started': 'phase-gray', 'in_progress': 'phase-blue', 'submitted': 'phase-green', 'reviewing': 'phase-orange', 'rejected': 'phase-red', 'approved': 'phase-green' }
      return map[s] || 'phase-gray'
    },
    
    showCreateDialog() {
      this.isEdit = false
      this.waveForm = { 
        name: '', 
        phases: [
          { phaseNo: 1, formId: '', phaseName: '神秘顾客信息' },
          { phaseNo: 3, formId: '', phaseName: '服务评分' }
        ],
        enablePhaseOrder: false,
        enableUniqueCode: 1,
        timeRange: [] 
      }
      this.dialogVisible = true
    },
    
    editWave(row) {
      this.isEdit = true
      this.currentWave = row
      // 从后端返回的 Phases 重建编辑数据
      const phases = row.Phases || row.phases || []
      let editPhases = []
      if (phases.length > 0) {
        editPhases = phases.map((p, idx) => ({
          phaseNo: parseInt(p.phaseNo || p.PhaseNo) || (idx + 1),
          formId: String(p.formId || p.FormId || ''),
          phaseName: p.phaseName || p.PhaseName || `阶段${idx + 1}`
        }))
      } else {
        // 兼容旧数据：FormKeys 是简单数组
        const formKeys = row.FormKeys || row.formKeys || []
        editPhases = (Array.isArray(formKeys) ? formKeys : [formKeys]).map((fk, idx) => ({
          phaseNo: idx + 1,
          formId: String(fk || ''),
          phaseName: `阶段${idx + 1}`
        }))
      }
      if (editPhases.length === 0) editPhases = [
        { phaseNo: 1, formId: '', phaseName: '神秘顾客信息' },
        { phaseNo: 3, formId: '', phaseName: '服务评分' }
      ]
      this.waveForm = {
        name: row.Name || row.name,
        phases: editPhases,
        enablePhaseOrder: !!(row.EnablePhaseOrder || row.enablePhaseOrder),
        enableUniqueCode: row.EnableUniqueCode !== undefined ? row.EnableUniqueCode : (row.enableUniqueCode !== undefined ? row.enableUniqueCode : 1),
        timeRange: (row.StartTime || row.startTime) && (row.EndTime || row.endTime) 
          ? [row.StartTime || row.startTime, row.EndTime || row.endTime] 
          : []
      }
      // 检测是否已生成一店一码（有门店已有UniqueCode）
      this.hasGeneratedCodes = !!(row._dealers && row._dealers.some(d => d.UniqueCode || d.uniqueCode))
      this.dialogVisible = true
    },
    
    async saveWave() {
      try {
        await this.$refs.waveForm.validate()
        this.saving = true
        
        // 构造 FormKeysJson（JSON阶段格式）
        const phasesJson = JSON.stringify(this.waveForm.phases.filter(p => p.formId).map(p => ({
          phaseNo: p.phaseNo,
          formId: p.formId,
          phaseName: p.phaseName || `阶段${p.phaseNo}`,
          required: true
        })))

        const data = {
          ProjectId: parseInt(this.projectId),
          Name: this.waveForm.name,
          FormKeysJson: phasesJson,
          EnablePhaseOrder: this.waveForm.enablePhaseOrder ? 1 : 0,
          EnableUniqueCode: this.waveForm.enableUniqueCode,
          StartTime: this.waveForm.timeRange?.[0] || null,
          EndTime: this.waveForm.timeRange?.[1] || null
        }
        
        if (this.isEdit) {
          data.id = this.currentWave.id || this.currentWave.Id
          await updateWave(data)
        } else {
          await createWave(data)
        }
        
        this.$message.success(this.isEdit ? '波次更新成功' : '波次创建成功')
        this.dialogVisible = false
        this.loadWaves()
      } catch (e) {
        if (e !== false) {
          this.$message.error('操作失败')
        }
      } finally {
        this.saving = false
      }
    },
    
    addPhase() {
      // 找到当前未使用的最小阶段号（1-4）
      const usedNos = new Set(this.waveForm.phases.map(p => p.phaseNo))
      let nextNo = 0
      for (let i = 1; i <= 4; i++) {
        if (!usedNos.has(i)) { nextNo = i; break }
      }
      if (!nextNo) return // 已满4个阶段
      const defaultNames = { 1: '神秘顾客信息', 2: '到店暗检', 3: '服务评分', 4: '总结反馈' }
      this.waveForm.phases.push({
        phaseNo: nextNo,
        formId: '',
        phaseName: defaultNames[nextNo] || `阶段${nextNo}`
      })
      // 按 phaseNo 排序
      this.waveForm.phases.sort((a, b) => a.phaseNo - b.phaseNo)
    },
    
    removePhase(idx) {
      this.waveForm.phases.splice(idx, 1)
      // 不重新编号，保留原始 phaseNo
    },
    
    deleteWave(row) {
      const waveId = row.Id || row.id
      const waveName = row.Name || row.name
      this.$confirm(`确定删除波次 "${waveName}" 吗？`, '提示', { type: 'warning' })
        .then(async () => {
          await deleteWaveApi(waveId)
          this.$message.success('删除成功')
          this.loadWaves()
        })
        .catch(() => {})
    },
    
    async toggleDealers(row) {
      // 如果还没加过数据，先加载再展开
      if (!row._dealers) {
        // 先初始化响应式属性，确保模板能正确渲染
        this.$set(row, '_dealers', [])
        this.$set(row, '_dealerLoading', true)
        this.$set(row, '_dealerPage', 1)
        this.$set(row, '_dealerTotal', 0)
        this.$set(row, '_filterKeyword', '')
        this.$set(row, '_filterAgent', null)
        this.$set(row, '_filterShopper', null)
        // 等 DOM 更新后再展开，避免展开时数据还未挂载
        this.$nextTick(() => {
          this.$refs.waveTable.toggleRowExpansion(row, true)
        })
        await this.loadDealerPage(row, 1)
      } else {
        // 已有数据，直接 toggle
        this.$refs.waveTable.toggleRowExpansion(row)
      }
    },
    
    async loadDealerPage(row, page) {
      const waveId = row.Id || row.id
      this.$set(row, '_dealerLoading', true)
      try {
        const params = { Page: page, PageSize: 10 }
        if (row._filterKeyword) params.Keyword = row._filterKeyword
        if (row._filterAgent != null) params.HasAgent = row._filterAgent
        if (row._filterShopper != null) params.HasShopper = row._filterShopper
        const res = await getWaveDealers(waveId, params)
        const data = res?.data?.data || res?.data || {}
        this.$set(row, '_dealers', data.Rows || data.rows || [])
        this.$set(row, '_dealerTotal', data.TotalRows || data.totalRows || data.Total || data.total || 0)
        this.$set(row, '_dealerPage', page)
      } catch (e) {
        console.error('加载经销商名单失败', e)
        this.$set(row, '_dealers', [])
      }
      this.$set(row, '_dealerLoading', false)
    },
    
    handleDealerPageChange(row, page) {
      this.loadDealerPage(row, page)
    },

    applyDealerFilter(row) {
      this.$set(row, '_dealerPage', 1)
      this.loadDealerPage(row, 1)
    },
    
    uploadDealers(row) {
      if (this.hasAssignedShopper(row)) {
        this.$message.warning('该波次已有神客分配，不能直接导入名单')
        return
      }
      this.currentWave = row
      this.uploadFile = null
      this.uploadDialogVisible = true
    },
    
    // 清空上传组件的文件列表
    clearUploadList() {
      this.fileList = []
      this.uploadFile = null
      if (this.$refs.uploadRef) {
        this.$refs.uploadRef.clearFiles()
      }
    },
    
    handleFileChange(file) {
      this.uploadFile = file.raw
    },
    
    async downloadTemplate() {
      try {
        const res = await exportDealerTemplate()
        const blobData = res.data || res
        const blob = new Blob([blobData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = '波次-经销商导入模板.xlsx'
        link.click()
        window.URL.revokeObjectURL(url)
      } catch (e) {
        this.$message.error('下载模板失败')
      }
    },
    
    async confirmUpload() {
      if (!this.uploadFile) {
        this.$message.warning('请选择文件')
        return
      }
      
      this.uploading = true
      try {
        const waveId = this.currentWave.Id || this.currentWave.id
        const formData = new FormData()
        formData.append('file', this.uploadFile)
        formData.append('waveId', waveId)
        await uploadDealerList(formData)
        
        this.$message.success('上传成功')
        this.uploadDialogVisible = false
        // 刷新门店列表
        if (this.currentWave._dealers) {
          this.$set(this.currentWave, '_dealers', null)
          this.toggleDealers(this.currentWave)
        }
        this.loadWaves()
      } catch (e) {
        this.$message.error('上传失败')
      } finally {
        this.uploading = false
      }
    },
    
    async generateCodes(row) {
      const waveId = row.Id || row.id
      this.$confirm('确定为该波次的所有经销商生成一店一码吗？', '提示')
        .then(async () => {
          await generateDealerCodes(waveId)
          this.$message.success('生成成功')
          this.loadWaves()
        })
        .catch(() => {})
    },
    
    async exportAssignList(row) {
      const waveId = row.Id || row.id
      const waveName = row.Name || row.name
      try {
        const res = await exportDealerAssignList(waveId)
        const blobData = res.data || res
        const blob = new Blob([blobData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = `${waveName}_分配名单.xlsx`
        link.click()
        window.URL.revokeObjectURL(url)
        this.$message.success('名单导出成功')
      } catch (e) {
        this.$message.error(e.message || '导出失败')
      }
    },

    async exportQRCodes(row) {
      const waveId = row.Id || row.id
      const waveName = row.Name || row.name
      try {
        const res = await exportDealerQRCodes(waveId)
        // 处理文件下载：axios 返回完整 response，数据在 res.data 中
        const blobData = res.data || res
        const blob = new Blob([blobData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = `${waveName}_经销商二维码.xlsx`
        link.click()
        window.URL.revokeObjectURL(url)
        this.$message.success('导出成功')
      } catch (e) {
        this.$message.error(e.message || '导出失败')
      }
    },
    
    // 复制链接到剪贴板
    copyLink(url) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(() => {
          this.$message.success('链接已复制')
        }).catch(() => {
          this.fallbackCopy(url)
        })
      } else {
        this.fallbackCopy(url)
      }
    },
    
    fallbackCopy(text) {
      const textarea = document.createElement('textarea')
      textarea.value = text
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand('copy')
      document.body.removeChild(textarea)
      this.$message.success('链接已复制')
    },
    
    async showChangeAgent(dealer) {
      // 检查是否已有问卷填写记录
      const phases = dealer.PhaseStatuses || dealer.phaseStatuses || []
      const hasSubmitted = phases.some(p => {
        const s = p.Status || p.status || ''
        return s === 'submitted' || s === 'approved' || s === 'reviewing' || s === 'in_progress'
      })

      if (hasSubmitted) {
        try {
          await this.$confirm(
            '该门店已有问卷填写记录。更换代理可能影响现有数据，确定继续？',
            '安全提醒',
            { type: 'warning', confirmButtonText: '继续更换', cancelButtonText: '取消', customClass: 'styled-msgbox' }
          )
        } catch { return }
      }

      this.agentDealer = dealer
      this.selectedAgentIds = []
      this.loadingAgentCurrent = true

      // 加载代理选项列表
      try {
        const res = await getAgentOptions(this.projectId)
        const data = res?.data?.data || res?.data || res || {}
        this.agentOptions = data.list || data.List || []
      } catch (e) {
        const data = e?.data?.data || e?.data || {}
        const list = data.list || data.List || []
        if (list.length > 0) {
          this.agentOptions = list
        } else {
          console.error('加载代理列表失败', e)
        }
      }

      // 加载当前已分配的代理
      try {
        const dealerId = dealer.Id || dealer.id
        const res = await getDealerAgents(dealerId)
        const data = res?.data?.data || res?.data || {}
        const ids = data.agentUserIds || data.AgentUserIds || []
        this.selectedAgentIds = ids.map(Number)
      } catch (e) {
        console.error('加载当前代理失败', e)
        // 回退到 AgentUserId 字段
        const agentId = dealer.AgentUserId || dealer.agentUserId || null
        this.selectedAgentIds = agentId ? [Number(agentId)] : []
      }

      this.loadingAgentCurrent = false
      this.agentDialogVisible = true
    },
    
    async confirmChangeAgent() {
      this.changingAgent = true
      try {
        const dealerId = this.agentDealer.Id || this.agentDealer.id
        await changeDealerAgent(dealerId, this.selectedAgentIds || [])
        this.$message.success('代理更换成功')
        this.agentDialogVisible = false
        // 刷新展开的经销商列表（保持当前页）
        const waveRow = this.waveList.find(w => (w._dealers || []).some(d => (d.Id || d.id) === dealerId))
        if (waveRow) {
          this.loadDealerPage(waveRow, waveRow._dealerPage || 1)
        }
      } catch (e) { this.$message.error(e?.message || '操作失败') }
      this.changingAgent = false
    }
  }
}
</script>

<style lang="scss" scoped>
.waves-container {
  padding: 0;
}

.waves-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  
  h3 {
    margin: 0;
    font-size: 18px;
    font-weight: 500;
  }
}

.text-danger {
  color: #f56c6c;
}

/* 展开区域 — 经销商子表格 */
.expand-dealer {
  padding: 12px 16px 16px;
  background: #f9fafb;
}
.dealer-header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}
.expand-title {
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  padding-left: 4px;
}
.dealer-filter-bar {
  display: flex;
  align-items: center;
  gap: 8px;
}
.sub-table {
  border: 1px solid #e5e7eb !important;
  border-radius: 8px !important;
  overflow: hidden;
}
.dealer-pagination {
  margin-top: 12px;
  display: flex;
  justify-content: flex-end;
}
/* 阶段状态标签 */
.phase-tag {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}
.phase-list {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}
.phase-gray { background: #f3f4f6; color: #6b7280; }
.phase-blue { background: #dbeafe; color: #2563eb; }
.phase-green { background: #d1fae5; color: #059669; }
.phase-orange { background: #fef3c7; color: #d97706; }
.phase-red { background: #fee2e2; color: #dc2626; }
/* 隐藏 expand 列的默认箭头，由"经销商"按钮触发 */
::v-deep .el-table__expand-icon {
  display: none !important;
}
::v-deep  .el-table__expand-column {
  width: 0 !important;
  padding: 0 !important;
  .cell { padding: 0 !important; width: 0 !important; }
}
.phase-type-hint {
  display: inline-block;
  margin-left: 8px;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  color: #909399;
  background: #f4f4f5;
}
.phase-hint-text {
  margin: 8px 0 0;
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
}

/* 新建按钮 — 匹配截图大圆角蓝色 */
.btn-create {
  border-radius: 8px !important;
  padding: 12px 24px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  height: auto !important;
  background-color: #2563eb !important;
  border-color: #2563eb !important;
  color: #fff !important;
  &:hover, &:focus {
    background-color: #1d4ed8 !important;
    border-color: #1d4ed8 !important;
  }
}

.text-muted {
  color: #909399;
}

.upload-tips {
  margin-top: 10px;
  font-size: 12px;
  line-height: 1.8;
  color: #606266;
  
  p { margin: 0; }
}

/* ===== el-dialog 样式覆盖 ===== */
::v-deep  .el-dialog {
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0,0,0,0.15);
  overflow: hidden;
  .el-dialog__header {
    padding: 20px 24px 16px;
    border-bottom: 1px solid #e5e7eb;
    .el-dialog__title {
      font-size: 16px;
      font-weight: 600;
      color: #111827;
    }
    .el-dialog__headerbtn {
      top: 20px;
      right: 20px;
      .el-dialog__close { font-size: 18px; color: #6b7280; }
    }
  }
  .el-dialog__body {
    padding: 24px;
  }
  .el-dialog__footer {
    padding: 16px 24px;
    border-top: 1px solid #e5e7eb;
  }
}
/* 上传区域样式 */
::v-deep  .el-upload-dragger {
  border: 2px dashed #d1d5db;
  border-radius: 10px;
  background: #fafafa;
  transition: border-color 0.2s;
  &:hover { border-color: #2563eb; }
  .el-icon-upload { font-size: 40px; color: #2563eb; margin-top: 30px; }
  .el-upload__text { color: #6b7280; em { color: #2563eb; font-style: normal; } }
}

/* ===== el-table 样式覆盖 — 匹配原型图 ===== */
.table-card {
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1), 0 1px 2px rgba(0,0,0,0.06);
  overflow: hidden;
}
.proto-table {
  /* 去掉 el-table 默认边框 */
  &.el-table { border: none; }
  &::before { display: none; }
  &::after { display: none; }
  ::v-deep  .el-table__header-wrapper {
    th {
      background: rgba(249,250,251,0.8) !important;
      border-bottom: 1px solid #e5e7eb !important;
      font-size: 13px;
      font-weight: 500;
      color: #6b7280;
      padding: 14px 0;
      .cell { padding: 0 12px; }
    }
  }
  ::v-deep .el-table__body-wrapper {
    td {
      border-bottom: 1px solid #e5e7eb !important;
      font-size: 14px;
      color: #111827;
      padding: 14px 0;
      .cell { padding: 0 12px; }
    }
    tr:last-child td { border-bottom: none !important; }
    tr:hover > td { background: rgba(249,250,251,0.8) !important; }
  }
  ::v-deep .el-table__body tr.hover-row > td { background: rgba(249,250,251,0.8) !important; }
}

/* 名称单元格 */
.name-cell {
  display: flex;
  align-items: center;
}

/* 图标方块 */
.icon-box {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  font-size: 20px;
  flex-shrink: 0;
  &.blue   { background: #dbeafe; color: #2563eb; }
  &.pink   { background: #fce7f3; color: #db2777; }
  &.green  { background: #d1fae5; color: #059669; }
  &.orange { background: #fef3c7; color: #d97706; }
  &.purple { background: #ede9fe; color: #7c3aed; }
  &.teal   { background: #ccfbf1; color: #0d9488; }
}

.row-title {
  font-size: 15px;
  font-weight: 700;
  color: #111827;
  line-height: 1.4;
  cursor: pointer;
  transition: color 0.15s;
  margin-bottom: 4px;
}
.el-table__body tr:hover .row-title { color: #2563eb; }
.row-sub {
  font-size: 12px;
  color: #6b7280;
}

/* 状态 — 药丸徽章 */
.status-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 9999px;
  font-size: 12px;
  font-weight: 600;
  .dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    margin-right: 6px;
    flex-shrink: 0;
  }
  &.success {
    background: #ecfdf5; color: #059669; border: 1px solid #a7f3d0;
    .dot { background: #10b981; }
  }
  &.warning {
    background: #fffbeb; color: #d97706; border: 1px solid #fde68a;
    .dot { background: #f59e0b; }
  }
  &.danger {
    background: #fef2f2; color: #dc2626; border: 1px solid #fecaca;
    .dot { background: #ef4444; }
  }
  &.info {
    background: #f3f4f6; color: #4b5563; border: 1px solid #e5e7eb;
    .dot { background: #9ca3af; }
  }
}

.count-num { font-weight: 600; }

.time-sub {
  font-size: 12px;
  color: #6b7280;
  margin-top: 2px;
}

.phase-config-row {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  
  .phase-no {
    min-width: 48px;
    font-size: 13px;
    color: #606266;
    font-weight: 500;
  }
}

/* 代理列 */
.agent-cell {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  padding: 2px 6px;
  border-radius: 4px;
  transition: background 0.15s;
  &:hover { background: #eff6ff; }
}

/* 弹窗按钮主题色 */
::v-deep .el-dialog .el-dialog__footer {
  .el-button--primary { background: #2563eb; border-color: #2563eb; border-radius: 9999px; &:hover { background: #1d4ed8; border-color: #1d4ed8; } }
  .el-button--default { border-color: #d1d5db; color: #374151; border-radius: 9999px; &:hover { border-color: #2563eb; color: #2563eb; } }
}
</style>

<style lang="scss">
/* MessageBox 全局样式（不能 scoped） */
.styled-msgbox {
  border-radius: 12px !important;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0,0,0,0.15) !important;

  .el-message-box__header {
    padding: 16px 20px !important;
    border-bottom: 1px solid #f3f4f6;
    .el-message-box__title { font-size: 16px; font-weight: 600; }
  }
  .el-message-box__content { padding: 20px !important; }
  .el-message-box__btns {
    padding: 12px 20px 16px !important;
    border-top: 1px solid #f3f4f6;
    .el-button {
      border-radius: 9999px !important;
    }
    .el-button--default {
      border-color: #d1d5db !important; color: #374151 !important;
      background: #fff !important;
      &:hover { border-color: #2563eb !important; color: #2563eb !important; }
    }
    .el-button--primary {
      background: #2563eb !important; border-color: #2563eb !important; color: #fff !important;
      &:hover { background: #1d4ed8 !important; border-color: #1d4ed8 !important; }
    }
  }
}
</style>
